$(document).ready(function(){
    //var conn = new WebSocket('ws://localhost:8080');
    //conn.onopen = function(e) {
    //    console.log("Connection established!");
    //};
//
    //conn.onmessage = function(e) {
    //    console.log(e.data);
    //};

    $('.block-recents .parentType a').on('click', function() {
        var dataType = $.parseJSON($(this).attr("data-type"));
        if(dataType.ajaxCall != "false"){
            $.ajax({
                url: rootUrl+'notifications/updateStatus',
                type: "POST",
                data: { objectId: dataType.id, objectType: dataType.type },
                async: true,
                success:function(data, textStatus){
                    //conn.send(dataType); //TODO : Nothing down right now but for future DOM update with socket
                },
                error:function(xhr, textStatus, thrownError){
                    alert('Erreur AJAX : '+thrownError + "data : " + data.objectId);
                }
            }, 'json')
        }
    });
});

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

function showModal(id_s, id_di, type) {
    if (type == 'question' || type == 'reponse') {
        document.location = rootUrl + 'operations/' + id_s + '/di/' + id_di + '#questionModal';
    } else if (type == 'document') {
        if (id_di != 'undefined') {
            document.location.href = rootUrl + 'operations/' + id_s + '/di/' + id_di + '#documentModal';
        } else {
            document.location.href = rootUrl + 'operations/' + id_s + '#documentModal';
        }
    }
}

window.onload = function () {
    var montantPourcentage = $('#chartContainerPie').data('array');
    var nombreOperationRefuse = $('#nombreOperationRefuse').data('array');
    var nombreOperationAccepte = $('#nombreOperationAccepte').data('array');
    var nombreOperationRefuseCopy=[];
    var nombreOperationAccepteCopy=[];
    var montantPourcentageCopy=[];
    $.each(montantPourcentage,function(index,value){
        montantPourcentageCopy[index]={indexLabel: value.indexLabel, code: value.code,  y:parseFloat(value.y)}  ;
    });
    $.each(nombreOperationRefuse,function(index,value){
        nombreOperationRefuseCopy[index]={x:new Date(value.z,value.x-1), y:parseInt(value.y)}  ;
    });
    $.each(nombreOperationAccepte,function(index,value){
        nombreOperationAccepteCopy[index]={x:new Date(value.z,value.x-1), y:parseInt(value.y)}  ;
    });
    montantPourcentage = montantPourcentageCopy;
    if(montantPourcentage.length>0) {
        var chartPie = new CanvasJS.Chart("chartContainerPie",
            {
                title: {
                    text: "Catégorie des interventions sur vos véhicules"
                },
                legend: {
                    maxWidth: 350,
                    itemWidth: 120
                },
                data: [
                    {
                        type: "pie",
                        toolTipContent:"{y}%",
                        dataPoints: montantPourcentage
                    }
                ]
            });
        chartPie.render();
    }

    if(nombreOperationAccepte.length>0 || nombreOperationRefuse.length>0) {
        CanvasJS.addCultureInfo("fr",
            {
                months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
                shortMonths: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"]
            });

        var chartBar = new CanvasJS.Chart("chartContainerBar",
            {
                title: {
                    text: "Opérations traitées/mois"
                },
                culture: 'fr',
                axisX: {
                    valueFormatString: "MMM YYYY"
                },
                data: [
                    {
                        type: "column",
                        color: "red",
                        xValueFormatString: "MMMM",
                        dataPoints: nombreOperationRefuseCopy,
                        showInLegend: true,
                        legendText: "Opération(s) refusée(s)"
                    },
                    {
                        type: "column",
                        color: "green",
                        xValueFormatString: "MMMM",
                        dataPoints: nombreOperationAccepteCopy,
                        showInLegend: true,
                        legendText: "Operation(s) accordée(s)"
                    }
                ]
            });
        chartBar.render();
    }
};
